// extracted by mini-css-extract-plugin
module.exports =  {"container":"BZVvXhJlhdZ7Vuv65xwg","btn":"ZKN08AjNu7vBV2RdpDzA","icon":"iqNi5tivbm5M0os4xbQl"};